/**
 * customer.ts Common Script File
 *
 * @project Codendot
 * @company Codendot <https://codendot.com>
 * @author Yahya Al Omar <yahya.a@codendot.com>
 * @since Thursday, November 17, 2022, 11:15 AM GMT+2
 *
 */
import AOS from 'aos';
import 'aos/dist/aos.css';


(() => {

    function main() {
        // initialize aos animation lib
        AOS.init({
            once: true,
        });

        // Get the body element
        const body = document.querySelector('body');
        const loader = document.querySelector('#loader-wrapper') as HTMLElement;

        // Remove the "loader-init" class and add the "loaded" class to the body element
        body?.classList.remove('loader-init');
        body?.classList.add('loaded');
        setTimeout(() => {
            loader.style.display = 'none';
        }, 400);
        // Bind a "beforeunload" event to the window object
        window.addEventListener('beforeunload', function () {
            // Remove the "loaded" class and add the "reload" class to the body element
            body?.classList.remove('loaded');
            body?.classList.add('reload');
        });

        window.addEventListener('scroll', function () {
            var header = document.querySelector('.header-wrapper') as HTMLElement;
            var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollPosition > 10) {
                header.style.backgroundColor = 'rgb(21 21 21 / 93%)';
            } else {
                header.style.backgroundColor = ''; // Reset to default background color
            }
        });

        const scrollDownButton = document.getElementById('scroll-down');
        const section1 = document.getElementById('section1');
        const header = document.getElementById('header'); // Replace 'header' with the actual ID of your header element

        if (scrollDownButton && section1 && header) {
            scrollDownButton.addEventListener('click', () => {
                const headerHeight = header.offsetHeight; // Get the height of the header
                const scrollOffset = section1.offsetTop - headerHeight; // Subtract the header height from the offset

                window.scrollTo({
                    top: scrollOffset,
                    behavior: 'smooth'
                });
            });
        }
    }

    document.addEventListener("readystatechange", async (event: any) => {
        if (event.target.readyState === 'complete') {
            main()
        }
    })




})()